import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body content mx-0 p-0" }
const _hoisted_8 = { class: "row p-4" }
const _hoisted_9 = { class: "col-lg-5" }
const _hoisted_10 = { class: "fw-bold ps-2 fs-7 mb-3" }
const _hoisted_11 = { class: "col-lg-7" }
const _hoisted_12 = { class: "fw-bold mb-3 fs-7 mt-5 mt-xxl-0" }
const _hoisted_13 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 align-items-center" }
const _hoisted_14 = { class: "w-max-content col-lg-5" }
const _hoisted_15 = { class: "col-lg-7 text-break" }
const _hoisted_16 = { class: "row mx-0 px-0 gx-3" }
const _hoisted_17 = { class: "w-max-content col-lg-5" }
const _hoisted_18 = { class: "col-lg-7" }
const _hoisted_19 = { class: "row p-4 d-flex justify-content-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = { class: "row mx-0 px-0 my-4 d-flex justify-content-center" }
const _hoisted_22 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_23 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }

import { computed, onMounted, PropType, ref } from 'vue'
import { useStore } from 'vuex'
import { Modal } from 'bootstrap'
import ModalComplete from './ModalComplete.vue'
import ChooseUser from '@/components/choose-user/index.vue'
import Button from '@/components/button/index.vue'
import { numberWithCommas } from '@/constants/common.ts'
import { translate } from '@/languages/i18n'
import { COMMUNITY_ALUMNUS_STORE } from '@/store/constants'
import communityAlumnusServices from '@/services/community-alumnus.services'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<{
    management_flag: 'add' | 'remove'
    settingFlag: 'add' | 'remove'
  }>,
  userSelected: Array as PropType<any[]>,
  getListUserFailed: Function as PropType<() => void | undefined>,
  typeModal: String as PropType<'user' | 'alumnai'>,
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()

const listFlags = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_LIST_MANAGING_FLAGS])

const modalComplete = ref()


const modal = ref()

onMounted(() => {
  modal.value = new Modal(document.getElementById('modalConfirm'))
})
const hanldeErrorServer = ref(false)
const loadingConfirm = ref(false)
const handleSubmit = async (): Promise<void> => {
  const { data, userSelected, getListUserFailed } = props
  getListUserFailed([])
  loadingConfirm.value = true
  try {
    const response = await communityAlumnusServices.updateManagementFlagApi({
      id: route.params?.id,
      data: {
        management_no: userSelected?.map((item: any) => item?.management_no),
        flag_id: data?.management_flag,
        type: data?.settingFlag,
      },
    })
    if (response.status === 200) {
      hanldeErrorServer.value = false
      getListUserFailed(response.data?.data?.data_failed?.map((item: any) => item.management_no) || [])
    } else {
      hanldeErrorServer.value = true
      getListUserFailed(userSelected?.map((item: any) => item?.management_no))
    }
    // 2022/09/12 TienNV Fix double click button confirm
    modal.value.hide()
    modalComplete.value?.show()
    setTimeout(() => {
      loadingConfirm.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    modal.value.hide()
    modalComplete.value?.show()
    hanldeErrorServer.value = true
    loadingConfirm.value = false
    getListUserFailed(userSelected?.map((item: any) => item?.management_no))
  }
}

onMounted(() => {
  modalComplete.value = new Modal(document.getElementById('modalConfirmAgain'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE53titleManagementFlag')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(numberWithCommas)(__props.userSelected?.length)) + _toDisplayString(_unref(translate)('selectingUserItems')), 1),
                  _createVNode(ChooseUser, {
                    data: __props.userSelected,
                    className: 'wrapper-user',
                    disabled: true
                  }, null, 8, ["data"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h6", _hoisted_12, _toDisplayString(_unref(translate)('OE53updateUserSelected')), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('OE53updateManagementFlag')), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(listFlags).find((item) => item?.id === __props.data?.management_flag)?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)('OE53flagSetting')), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(translate)(__props.data?.settingFlag === 'add' ? 'OE53flag' : 'OE53removeFlag')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)('OE53confirmText')), 1),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(Button, {
                    title: _unref(translate)('cancel'),
                    "data-bs-dismiss": "modal",
                    type: 'secondary'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(Button, {
                    title: _unref(translate)('update'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    onClick: handleSubmit,
                    disabled: loadingConfirm.value,
                    loading: loadingConfirm.value
                  }, null, 8, ["title", "disabled", "loading"])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(ModalComplete, {
      hanldeErrorServer: hanldeErrorServer.value,
      listUserFailed: _ctx.listUserFailed,
      data: _ctx.selectedUsers,
      typeModal: __props.typeModal
    }, null, 8, ["hanldeErrorServer", "listUserFailed", "data", "typeModal"])
  ], 64))
}
}

})